// PLOW rows alternate between two tones, the way the spreadsheet the board
// replaced did. A week is seven columns wide and the only thing tying a
// Friday cell to a person is horizontal alignment, which the eye loses on a
// board of any length.
//
// The band is painted on the row, not on its cells: the day cells used to
// carry an opaque bg-white of their own, which would cover it. They sit
// transparent over the row now, and the weekend columns add a translucent
// wash so they read a shade deeper than whichever band is underneath rather
// than replacing it.
//
// Every class here has a .dark override in styles.css, so the banding follows
// the app's light and dark themes; a test holds that.

export const PLOW_ROW_TONES = [
  { row: 'bg-white', name: 'bg-white' },
  { row: 'bg-gray-50', name: 'bg-gray-50' },
];

// The signed-in person's own row keeps its blue highlight and sits outside
// the banding, so it reads as the one row that is different rather than as
// one more stripe. The name cell is the solid tint the rest of the row wears
// at 40%, which is what makes the person column the anchor of the row.
export const PLOW_MY_ROW_TONE = { row: 'bg-blue-50/40', name: 'bg-blue-50' };

export const PLOW_WEEKEND_WASH = 'bg-gray-100/60';

export function plowRowTone(index, { isCurrentUser = false } = {}) {
  if (isCurrentUser) return PLOW_MY_ROW_TONE;
  return PLOW_ROW_TONES[index % PLOW_ROW_TONES.length];
}
